var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Radar',{attrs:{"chart-data":_vm.RadarChartData,"chart-options":_vm.RadarChartDataOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }